import { AxiosRequestConfig } from "axios";

import { ApiError, GeoFenceLocation, Variable } from "@/types";
import { fetchData } from "@/utils";

type GetVariablesApiResponse = {
  data: Variable[];
  error: ApiError | null;
};

export const getVariables = async (
  accessToken: string,
  client: string,
): Promise<GetVariablesApiResponse> => {

  let url = `${process.env.REACT_APP_API_URL}/v2/tags?client=${client}`;

  const config: AxiosRequestConfig = {
    method: "GET",
    url,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  };

  return fetchData(config);
};

type GetDiscoverVariablesApiResponse = {
  data: Variable[];
  error: ApiError | null;
};

export const getDiscoverVariables = async (
  accessToken: string,
): Promise<GetDiscoverVariablesApiResponse> => {
  let url = `${process.env.REACT_APP_API_URL}/v2/ots`;

  const config: AxiosRequestConfig = {
    method: "GET",
    url,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  };

  return fetchData(config);
};

type GetLocationsApiResponse = {
  data: GeoFenceLocation[];
  error: ApiError | null;
};

export const getLocations = async (
  accessToken: string,
): Promise<GetLocationsApiResponse> => {
  let url = `${process.env.REACT_APP_API_URL}/v2/locations`;

  const config: AxiosRequestConfig = {
    method: "GET",
    url,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  };

  return fetchData(config);
};
